// filepath: /home/toofoocustomer/tf-node/tf_customer_web/components/customer/AccountPanel.tsx

"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

import { CustomerCoreProfilePanel } from "@/components/customer/CustomerCoreProfilePanel";

import {
  CustomerSession,
  customerIdentityErrorMessage,
  getCustomerSession,
  logoutCustomer,
} from "@/lib/customer/identity-api";

export function AccountPanel() {
  const [session, setSession] = useState<CustomerSession | null>(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [loggingOut, setLoggingOut] = useState(false);

  useEffect(() => {
    void (async () => {
      try {
        setSession(await getCustomerSession());
      } catch (error) {
        setErrorMessage(customerIdentityErrorMessage(error, "session"));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function logout() {
    setLoggingOut(true);
    setErrorMessage("");
    try {
      await logoutCustomer();
      window.location.replace("/login");
    } catch (error) {
      setErrorMessage(customerIdentityErrorMessage(error, "logout"));
      setLoggingOut(false);
    }
  }

  if (loading) {
    return <div className="status-card" data-e2e="customer-account-loading">계정 정보를 확인하고 있습니다.</div>;
  }

  if (errorMessage) {
    return <div className="form-error" role="alert">{errorMessage}</div>;
  }

  if (!session?.authenticated) {
    return (
      <div className="status-card" data-e2e="customer-account-signed-out">
        <h1>로그인이 필요합니다</h1>
        <p>TOOFOO 계정으로 로그인하면 서비스를 계속 이용할 수 있습니다.</p>
        <Link className="primary-button link-button" href="/login">로그인</Link>
      </div>
    );
  }

  return (
    <div className="account-stack" data-e2e="customer-account-authenticated">
      <div className="account-card">
        <div>
          <p className="eyebrow">MY TOOFOO</p>
          <h1>계정</h1>
          <p className="account-email">{session.email ?? "확인된 이메일"}</p>
        </div>
        <div className="account-actions">
          <button className="secondary-button" type="button" onClick={logout} disabled={loggingOut}>
            {loggingOut ? "로그아웃 중..." : "로그아웃"}
          </button>
        </div>
      </div>

      <section className="account-section account-entry-section" aria-labelledby="account-security-entry-title">
        <div className="account-section-title-row">
          <div>
            <p className="eyebrow">SECURITY &amp; ACCOUNT</p>
            <h2 id="account-security-entry-title">보안과 계정 관리</h2>
            <p>기기·세션 관리와 TOOFOO 회원 탈퇴는 Support Web의 전용 화면에서 진행합니다.</p>
          </div>
        </div>
        <div className="account-entry-grid">
          <Link className="account-entry-card" href="/account/security">
            <strong>기기와 보안</strong>
            <span>현재 로그인, Social 주 모바일·보조 기기, 다른 세션 관리</span>
          </Link>
          <Link className="account-entry-card account-entry-card--danger" href="/account/delete">
            <strong>TOOFOO 회원 탈퇴</strong>
            <span>Common Identity가 소유하는 전체 TOOFOO 회원 탈퇴</span>
          </Link>
        </div>
      </section>

      <CustomerCoreProfilePanel />
    </div>
  );
}
